import React from 'react';
import { Field } from 'react-final-form';
import moment from 'moment';

import { ButtonV2, DatePickerInputAdapter as DatePickerInput } from '@zola/zola-ui';

import { isMobile } from 'lib/responsive';
import { composeValidators } from 'components/common/form/FinalFormV2Elements';
import * as Validations from 'components/common/form/commonValidations';

import css from 'stylesheets/common/_modal.module.less';
import modal from './WeddingDateModal.module.less';

// date helpers
export const dataFormat = 'YYYY-MM-DD';
export const inputFormat = 'MM/DD/YYYY';
const parseDate = date => {
  if (moment(date, inputFormat, true).isValid()) {
    return moment(date, inputFormat).toDate();
  }
  return null;
};
const formatDate = date => {
  return moment(date).format(inputFormat);
};

// validator
const validator = composeValidators(Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE);

const WeddingDateForm = formProps => {
  const fullWidth = isMobile();
  return (
    <form onSubmit={formProps.handleSubmit}>
      <Field name="wedding_date" validate={validator}>
        {fieldProps => {
          const { input, meta } = fieldProps;
          return (
            <>
              <DatePickerInput
                parseDate={parseDate}
                formatDate={formatDate}
                className={modal.modalDatePicker}
                inputFieldProps={{ input, meta }}
              />
              <div className={css.footer}>
                <ButtonV2 type="submit" fullWidth={fullWidth}>
                  Make Website Visible
                </ButtonV2>
              </div>
            </>
          );
        }}
      </Field>
    </form>
  );
};

export default WeddingDateForm;



// WEBPACK FOOTER //
// ./src/components/common/modals/WeddingDateModal/WeddingDateForm.jsx